import { render, staticRenderFns } from "./FormMobilePageEditor.vue?vue&type=template&id=13973655&scoped=true"
import script from "./FormMobilePageEditor.vue?vue&type=script&lang=js"
export * from "./FormMobilePageEditor.vue?vue&type=script&lang=js"
import style0 from "./FormMobilePageEditor.vue?vue&type=style&index=0&id=13973655&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13973655",
  null
  
)

export default component.exports